module.exports = __webpack_public_path__ + "img/Logo.b0e419eb.png";